import { Box, Card, Chip, CircularProgress, Grid, Typography } from '@mui/joy'
import React from 'react'
import { StatsResponse } from '../types'

interface StatsPanelProps {
    stats: StatsResponse | null
    loading: boolean
}

export const StatsPanel: React.FC<StatsPanelProps> = ({ stats, loading }) => {
    if (loading) {
        return (
            <Card variant="outlined" sx={{ p: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 100 }}>
                    <CircularProgress />
                </Box>
            </Card>
        )
    }

    if (!stats) {
        return null
    }

    const progress = stats.total > 0 ? ((stats.labeled / stats.total) * 100).toFixed(1) : 0

    return (
        <Card variant="outlined" sx={{ p: 3, mb: 3 }}>
            <Typography level="h4" sx={{ mb: 2 }}>
                Labeling Progress
            </Typography>

            <Grid container spacing={2}>
                <Grid xs={12} sm={6} md={2.4}>
                    <Box>
                        <Typography level="body-sm" sx={{ mb: 0.5, color: 'text.secondary' }}>
                            Total Documents
                        </Typography>
                        <Typography level="h3">{stats.total.toLocaleString()}</Typography>
                    </Box>
                </Grid>

                <Grid xs={12} sm={6} md={2.4}>
                    <Box>
                        <Typography level="body-sm" sx={{ mb: 0.5, color: 'text.secondary' }}>
                            Labeled
                        </Typography>
                        <Typography level="h3">{stats.labeled.toLocaleString()}</Typography>
                        <Chip size="sm" color="primary" sx={{ mt: 0.5 }}>
                            {progress}%
                        </Chip>
                    </Box>
                </Grid>

                <Grid xs={12} sm={6} md={2.4}>
                    <Box>
                        <Typography level="body-sm" sx={{ mb: 0.5, color: 'text.secondary' }}>
                            Accepted
                        </Typography>
                        <Typography level="h3" sx={{ color: 'success.500' }}>
                            {stats.accepted.toLocaleString()}
                        </Typography>
                    </Box>
                </Grid>

                <Grid xs={12} sm={6} md={2.4}>
                    <Box>
                        <Typography level="body-sm" sx={{ mb: 0.5, color: 'text.secondary' }}>
                            Rejected
                        </Typography>
                        <Typography level="h3" sx={{ color: 'danger.500' }}>
                            {stats.rejected.toLocaleString()}
                        </Typography>
                    </Box>
                </Grid>

                <Grid xs={12} sm={6} md={2.4}>
                    <Box>
                        <Typography level="body-sm" sx={{ mb: 0.5, color: 'text.secondary' }}>
                            Remaining
                        </Typography>
                        <Typography level="h3">{stats.remaining.toLocaleString()}</Typography>
                    </Box>
                </Grid>
            </Grid>
        </Card>
    )
}
